import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { Col, Dropdown, DropdownMenu, DropdownToggle, Row } from 'reactstrap';
import classnames from "classnames";
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import Lottie from 'react-lottie-player';
import studio from '../../assets/images/products/studio.png';
import feed from '../../assets/images/products/feeds.png';
import lp from '../../assets/images/products/landing.png';
import activities from '../../assets/images/products/activities.png';
import campaigns from '../../assets/images/products/campaigns.png';
import analytics from '../../assets/images/products/analytics.png';
import studioJson from '../../assets/images/products/studio.json';
import feedJson from '../../assets/images/products/feeds.json';
import lpJson from '../../assets/images/products/landing.json';
import activitiesJson from '../../assets/images/products/activities.json';
import campaignsJson from '../../assets/images/products/campaigns.json';
import analyticsJson from '../../assets/images/products/analytics.json';
import fontsJson from '../../assets/images/products/fonts.json';
import TopMenuLottie from './TopMenuLottie';
import { useMatchedParams } from '../../slices/auth/settings/helper';
import campaignsSvg from '../../assets/images/svg/campaigns.svg';
import feedsSvg from '../../assets/images/svg/feeds.svg';
import analyticsSvg from '../../assets/images/svg/analytics.svg';
import fontsSvg from '../../assets/images/svg/fonts.svg';
import feedsImg from '../../assets/images/products/platform_feeds_icon_2.png';
import campaignsImg from '../../assets/images/products/platform_campaigns_icon.png';
import analyticsImg from '../../assets/images/products/platform_analytics.png';
import { setBreadcrumb } from '../../slices/auth/menu/reducer';
import checkPermission from '../../Components/Hooks/PermissionHook';
import { getFeedSuccess, setFeedsFirstLoad, setFeedsHasMore, setFeedsLoading, setFeedsPage } from '../../slices/feeds/reducer';
import { getAllLibrariesSuccess, setAllLibrariesFirstLoad, setAllLibrariesHasMore, setAllLibrariesLoading, setAllLibrariesPage } from '../../slices/campaigns/reducer';


function ProductsDropdown() {
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const path = getCurrentProductPath();

  const [isWebAppDropdown, setIsWebAppDropdown] = useState(false);
  const toggleWebAppDropdown = () => {
    setIsWebAppDropdown(!isWebAppDropdown);
  };

  const selectStates = createSelector((state) => state, state => ({
    menuData: state.MenuData.client,
    clientPath: state.MenuData.clientPath,
    brandPath: state.MenuData.brandPath,
    marketPath: state.MenuData.marketPath,
    permission: state.Permission.permission
  }));
  const { menuData, clientPath, brandPath, marketPath, permission } = useSelector(selectStates);

  const [canSeeFeeds, setCanSeeFeeds] = useState(false);
  const [canSeeCampaigns, setCanSeeCampaigns] = useState(false);
  const [canSeeAnalytics, setCanSeeAnalytics] = useState(false);

  function getCurrentProductPath() {
    let values = Object.values(params);
    let urlParts = location.pathname.split('/');
    let filteredParts = urlParts.filter(part => !values.includes(part));
    return filteredParts[1];
  }

  function getCurrentProduct() {
    if (location.pathname.includes('feed')) {
      return (
        <div className='w-100 d-flex align-items-center justify-content-center'>
          <img src={feedsImg} height='25' />
          {/* <p className='m-0'>Feeds</p> */}
        </div>
      );
    } else if (location.pathname.includes('campaign') || location.pathname.includes('publish')) {
      return (
        <div className='w-100 d-flex align-items-center justify-content-center'>
          <img src={campaignsImg} height='25' />
          {/* <p className='m-0'>Campaigns</p> */}
        </div>
      );
    } else if (location.pathname.includes('analytics')) {
      return (
        <div className='w-100 d-flex align-items-center justify-content-center'>
          <img src={analyticsImg} height='25' />
          {/* <p className='m-0'>Analytics</p> */}
        </div>
      );
    }
    // else if (location.pathname.includes('font')) {
    //   return (
    //     <div className='w-100 d-flex align-items-center justify-content-center'>
    //       <img src={fontsImg} height='25' className='me-1' />
    //       {/* <p className='m-0'>Fonts</p> */}
    //     </div>
    //   );
    // }
  }

  function resetBreadcrumb() {
    // Feed Table Reset
		dispatch(getFeedSuccess(null));
		dispatch(setFeedsLoading(false));
		dispatch(setFeedsHasMore(true));
		dispatch(setFeedsFirstLoad(false));
		dispatch(setFeedsPage(1));
		// Campaign Table Reset
		dispatch(getAllLibrariesSuccess(null));
		dispatch(setAllLibrariesLoading(false));
		dispatch(setAllLibrariesHasMore(true));
		dispatch(setAllLibrariesFirstLoad(false));
		dispatch(setAllLibrariesPage(1));
    dispatch(setBreadcrumb({ pageTitle: '', title: [] }));
  }

  useEffect(() => {
    if (permission) {
      if (marketPath && Object.keys(permission['markets'].length > 0)) {
        setCanSeeCampaigns((permission['markets'][marketPath]?.permissionsWK.includes('campaignView') || permission['brands'][brandPath]?.permissionsWK.includes('figmaTemplateCreate')))
        setCanSeeFeeds(permission['markets'][marketPath]?.permissionsWK.includes('feedView'))
        setCanSeeAnalytics(permission['markets'][marketPath]?.permissionsWK.includes('campaignAnalyze'))
      } else if (brandPath && Object.keys(permission['brands'].length > 0)) {
        setCanSeeCampaigns((permission['brands'][brandPath]?.permissionsWK.includes('campaignView') || permission['brands'][brandPath]?.permissionsWK.includes('figmaTemplateCreate')))
        setCanSeeFeeds(permission['brands'][brandPath]?.permissionsWK.includes('feedView'));
        setCanSeeAnalytics(permission['brands'][brandPath]?.permissionsWK.includes('campaignAnalyze'));
      } else if (clientPath && Object.keys(permission['clients'].length > 0)) {
        if (clientPath !== '1') {
          setCanSeeCampaigns(permission['clients'][clientPath]?.permissionsWK.includes('campaignView'));
          setCanSeeFeeds(permission['clients'][clientPath]?.permissionsWK.includes('feedView'));
          setCanSeeAnalytics(permission['clients'][clientPath]?.permissionsWK.includes('campaignAnalyze'))
        } else {
          setCanSeeCampaigns(permission['companies'][menuData._id]?.permissionsWK.includes('campaignView'));
          setCanSeeFeeds(permission['companies'][menuData._id]?.permissionsWK.includes('feedView'));
          setCanSeeAnalytics(permission['companies'][menuData._id]?.permissionsWK.includes('campaignAnalyze'))
        }
      } else if (menuData._id && Object.keys(permission['companies'].length > 0)) {
        setCanSeeCampaigns(permission['companies'][menuData._id]?.permissionsWK.includes('campaignView'));
        setCanSeeFeeds(permission['companies'][menuData._id]?.permissionsWK.includes('feedView'));
        setCanSeeAnalytics(permission['companies'][menuData._id]?.permissionsWK.includes('campaignAnalyze'));
      } else {
        setCanSeeCampaigns(false);
        setCanSeeFeeds(false);
        setCanSeeAnalytics(false);
      }
    }
  }, [clientPath, brandPath, marketPath]);

  return (
    <React.Fragment>

      {location.pathname.includes('feeds') || !location.pathname.includes('settings') ?
        <div className='topbar-head'>
          <div className='topbar-head-mobile'>
            <Dropdown isOpen={isWebAppDropdown} toggle={toggleWebAppDropdown} className="topbar-head-dropdown header-item">
              <DropdownToggle tag="button" type="button" className="w-100 btn btn-topbar navbar-products-btn">
                {/* <i className='bx bx-category-alt fs-22'></i> */}
                {getCurrentProduct()}
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-lg p-0 dropdown-menu-end">
                <div className="p-2">
                  <div className="row g-0">
                    {/* <Col>
                   <Link className={"dropdown-icon-item d-flex flex-column align-items-center justify-content-center p-0 " + classnames({ "active": path === "studio" })}
                     to={`/${useMatchedParams(params, menuData)}/fonts`} onClick={resetBreadcrumb}>
                     <TopMenuLottie animationData={fontsJson} style={{ width: 75, height: 75 }} goToProp={71} />
                     <span>Fonts</span>
                   </Link>
                 </Col> */}
                    {canSeeCampaigns ?
                      <Col>
                        <Link className={"dropdown-icon-item d-flex flex-column align-items-center justify-content-center p-0 " + classnames({ "active": path === "campaigns" })}
                          to={`/${useMatchedParams(params, menuData)}/campaigns/filter/all`} onClick={resetBreadcrumb}>
                          {/* <TopMenuLottie animationData={campaignsJson} style={{ width: 75, height: 75 }} /> */}
                          <img src={campaignsImg} style={{ width: "75px", height: '75px' }} />
                          <span>Campaigns</span>
                        </Link>
                      </Col>
                      : null}
                    {canSeeFeeds ?
                      <Col>
                        <Link className={"dropdown-icon-item d-flex flex-column align-items-center justify-content-center p-0 " + classnames({ "active": path === "feeds" })}
                          to={`/${useMatchedParams(params, menuData)}/feeds`} onClick={resetBreadcrumb}>
                          <img src={feedsImg} style={{ width: "75px", height: '75px' }} />
                          {/* <TopMenuLottie animationData={feedJson} style={{ width: 75, height: 75 }} /> */}
                          <span>Feeds</span>
                        </Link>
                      </Col>
                      : null}
                    {canSeeAnalytics ?
                      <Col>
                        <Link className={"dropdown-icon-item d-flex flex-column align-items-center justify-content-center p-0 " + classnames({ "active": path === "analytics" })}
                          to={`/${useMatchedParams(params, menuData)}/analytics`} onClick={resetBreadcrumb}>
                          {/* <TopMenuLottie animationData={analyticsJson} style={{ width: 75, height: 75 }} /> */}
                          <img src={analyticsImg} style={{ width: '75px', height: '75px' }} />
                          <span>Analytics</span>
                        </Link>
                      </Col>
                      : null}
                    {/* <Col>
                  <Link className={"dropdown-icon-item d-flex flex-column align-items-center justify-content-center p-0 " + classnames({ "active": path === "landing-pages" })}
                    to={`/`} onClick={resetBreadcrumb}>
                    <TopMenuLottie animationData={lpJson} style={{ width: 75, height: 75 }} />
                    <span>Landing Pages</span>
                  </Link>
                </Col> */}
                  </div>

                  {/* <div className="row g-0"> */}
                  {/* <Col>
                  <Link className={"dropdown-icon-item d-flex flex-column align-items-center justify-content-center p-0 " + classnames({ "active": path === "activities" })}
                    to={`/${useMatchedParams(params, menuData)}/activities/activity-groups`} onClick={resetBreadcrumb}>
                    <TopMenuLottie animationData={activitiesJson} style={{ width: 75, height: 75 }} />
                    <span>Activities</span>
                  </Link>
                </Col> */}

                  {/* </div> */}
                </div>
              </DropdownMenu>
            </Dropdown>
          </div >
          <div className='topbar-head-desktop row g-0 w-100'>
            {canSeeCampaigns ?
              <Col>
                <Link className={"dropdown-icon-item d-flex flex-column align-items-center justify-content-center p-0 " + classnames({ "active": path === "campaigns" })}
                  to={`/${useMatchedParams(params, menuData)}/campaigns/filter/all`} onClick={resetBreadcrumb}>
                  {/* <TopMenuLottie animationData={campaignsJson} style={{ width: 75, height: 75 }} /> */}
                  <img src={campaignsImg} style={{ width: "45px", height: '45px' }} />
                  <span>Campaigns</span>
                </Link>
              </Col>
              : null}
            {canSeeFeeds ?
              <Col>
                <Link className={"dropdown-icon-item d-flex flex-column align-items-center justify-content-center p-0 " + classnames({ "active": path === "feeds" })}
                  to={`/${useMatchedParams(params, menuData)}/feeds`} onClick={resetBreadcrumb}>
                  <img src={feedsImg} style={{ width: "45px", height: '45px' }} />
                  {/* <TopMenuLottie animationData={feedJson} style={{ width: 75, height: 75 }} /> */}
                  <span>Feeds</span>
                </Link>
              </Col>
              : null}
            {canSeeAnalytics ?
              <Col>
                <Link className={"dropdown-icon-item d-flex flex-column align-items-center justify-content-center p-0 " + classnames({ "active": path === "analytics" })}
                  to={`/${useMatchedParams(params, menuData)}/analytics`} onClick={resetBreadcrumb}>
                  {/* <TopMenuLottie animationData={analyticsJson} style={{ width: 75, height: 75 }} /> */}
                  <img src={analyticsImg} style={{ width: '45px', height: '45px' }} />
                  <span>Analytics</span>
                </Link>
              </Col> : null}
          </div>
        </div >
        : null
      }
    </React.Fragment >
  )
}

export default ProductsDropdown;